import React from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import MainApp from "./pages/MainApp";
import CreateSale from "./pages/CreateSale";
import SaleDetail from "./pages/SaleDetail";
import MyListings from "./pages/MyListings";
import PricingPage from "./pages/PricingPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import ReferralPage from "./pages/ReferralPage";
import ContactPage from "./pages/ContactPage";
import ShopPage from "./pages/ShopPage";
import ShopItemDetail from "./pages/ShopItemDetail";
import PostMerchandise from "./pages/PostMerchandise";
import PastSalesPage from "./pages/PastSalesPage";
import EditSale from "./pages/EditSale";
import SavedSales from "./pages/SavedSales";
import AdminDashboard from "./pages/AdminDashboard";
import HireAgentPage from "./pages/HireAgentPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="flex items-center justify-center min-h-screen" data-testid="loading-screen">
      <div className="text-xl font-bold text-[#004E89]">Loading...</div>
    </div>
  );
  if (!user) return <Navigate to="/login" />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) return (
    <div className="flex items-center justify-center min-h-screen" data-testid="loading-screen">
      <div className="text-xl font-bold text-[#004E89]">Loading...</div>
    </div>
  );

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={user ? <Navigate to="/explore" /> : <LandingPage />} />
        <Route path="/login" element={user ? <Navigate to="/explore" /> : <LoginPage />} />
        <Route path="/register" element={user ? <Navigate to="/explore" /> : <RegisterPage />} />
        <Route path="/explore" element={<MainApp />} />
        <Route path="/create" element={<ProtectedRoute><CreateSale /></ProtectedRoute>} />
        <Route path="/edit-sale/:saleId" element={<ProtectedRoute><EditSale /></ProtectedRoute>} />
        <Route path="/sale/:saleId" element={<SaleDetail />} />
        <Route path="/my-listings" element={<ProtectedRoute><MyListings /></ProtectedRoute>} />
        <Route path="/saved" element={<ProtectedRoute><SavedSales /></ProtectedRoute>} />
        <Route path="/referral" element={<ProtectedRoute><ReferralPage /></ProtectedRoute>} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/shop/:merchId" element={<ShopItemDetail />} />
        <Route path="/post-merchandise" element={<ProtectedRoute><PostMerchandise /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        <Route path="/hire" element={<HireAgentPage />} />
        <Route path="/past-sales" element={<PastSalesPage />} />
        <Route path="/payment-success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
        <Route path="/payment-cancel" element={<Navigate to="/pricing" />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
